import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React, { useState, useEffect } from 'react';
import { Col, Card, Row, Tabs, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ClaimGroupUserAccessForm from './ClaimGroupUserAccessForm';
import UserProjectAccess from './UserProjectAccess';
import UnitsAndProjectsUserAccessesList from './UnitsAndProjectsUserAccessesList';
import FoldersAndFilesUserAccessesList from './FoldersAndFilesUserAccessesList';
const EditUserAccessModal = _ref => {
  let {
    show,
    title,
    onHide,
    onSubmit,
    userAccess,
    company,
    claimGroup,
    setClaimGroup,
    onClaimScheduleClientContactParticipationChange
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [clientContact, setClientContact] = useState({
    ...userAccess
  });
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setClientContact({
      ...userAccess
    });
  }, [userAccess]);
  const clientContactModalBody = () => /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement(ClaimGroupUserAccessForm, {
    clientContact: clientContact,
    setClientContact: setClientContact
  })), /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(UserProjectAccess, {
    onClaimScheduleClientContactParticipationChange: onClaimScheduleClientContactParticipationChange,
    userAccess: clientContact,
    setClientContact: setClientContact,
    company: company,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    loading: loading,
    setLoading: setLoading
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "projects_and_units"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "projects_and_units",
    title: t('projects_and_business_units')
  }, /*#__PURE__*/React.createElement(UnitsAndProjectsUserAccessesList, {
    userAccess: clientContact,
    onClaimScheduleClientContactParticipationChange: onClaimScheduleClientContactParticipationChange,
    setLoading: setLoading,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    loading: loading
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "folders_and_files",
    title: t('individual_file_folder_access')
  }, /*#__PURE__*/React.createElement(FoldersAndFilesUserAccessesList, {
    userAccess: clientContact,
    onClaimScheduleClientContactParticipationChange: onClaimScheduleClientContactParticipationChange,
    setLoading: setLoading,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    loading: loading
  })))))))));
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: t(title),
    show: show,
    renderBody: () => clientContactModalBody(),
    onHide: onHide,
    onSubmit: () => onSubmit(clientContact),
    submitText: t('save'),
    closeText: t('cancel')
  });
};
export default EditUserAccessModal;